// import content from "containers/Sales/dashboard";
import { PartnerRequestIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";
import SessionClient from "util/SessionClient";

const content = l(() => import("containers/Sales/UserPartnerRequest"));

const { USER_PARTNER_REQUEST_ACCESS } = permissionTypes;
const session = new SessionClient();

export default {
  key: "partner-request",
  title: "Partner Request",
  path: "/partner-request",
  exact: true,
  linkTarget: "/partner-request",
  linkTitle: "Partner Request",
  linkCategory: "Sales",
  icon: PartnerRequestIcon,
  basePath: "partner-request",
  requiredParams: [],
  optionalParams: [],
  tabs: null,
  content,
  sidebar: null,
  permission: [USER_PARTNER_REQUEST_ACCESS],
  hideRoute: session.hasSeat,
};
